<template>
  <div id="topBg" class="section" >
    <h1>栄養の日・栄養週間 2020</h1>
    <div class="catch-wrap">
      <Catch />
    </div>
    <div class="circle-wrap hideSp">
      <Graphic />
    </div>
    <div class="bg-texture hideSp"></div>
  </div>
</template>

<script>
import Graphic from '@/assets/graphic1.svg?inline'
import Catch from '@/assets/catch.svg?inline'

export default {
  name: 'secTop',
  props: {
    
  },
  components:{
    Graphic,
    Catch
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#topBg{
  position: fixed;
  width: 100vw;
  height: 100vh;
  min-height: 720px;
  z-index: -1;
  display: block;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  overflow: hidden;
  background: #fff;
  @media #{$maxM}{
    position: relative;
    justify-content: center;
    align-items: center;
    background: transparent;
    overflow: visible;
  }
  @media #{$IE}{
    z-index: 0;
    overflow: inherit;
  }
  h1{
    opacity: 0;
    position: absolute;
  }

  .catch-wrap{
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-end;
    margin-top: 27.3vh;
    margin-right: 10vw;
    @media #{$maxM}{
      justify-content: flex-start;
      align-items: center;
      min-height: unset;
      margin: 0 auto;
    }
    @media screen and (min-width: 1919px){
          margin-right: 12vw;
    }
      svg{
        width: 24.158vw;
        min-width: 300px;
        max-width: 400px;
        display: block;
        position: relative;
        @media #{$IE}{
          height: 30vh;
        }
        @media #{$maxM}{
          width: 60.8vw;
          max-width: 420px;
          min-width: unset;
          position: relative;
        }
      }
  }
  .circle-wrap{
    display: block;
    width: 75vw;
    height: 150vh;
    min-width: 860px;
    min-height: 1054px;
    position: absolute;
    top: -50%;
    right: -25%;
      svg{
        width: 100%;
        height: 100%;
        animation-name: rotateOnly;
        animation-iteration-count: infinite;
        animation-duration: 24s;
        animation-timing-function: linear;
      }
  }
}

</style>
